import { call, put } from 'redux-saga/effects'
import { getData as apiGetData } from 'api/Api'
import {
  refreshBoards,
  setBoardsLoadStatus,
  addBoards as addBoardsToUserGroup
} from 'store/redux/userGroups'

export default function * fetchUserGroupBoards (action) {
  const { id, refresh } = action.payload

  const batchedActions = []

  if (refresh) {
    batchedActions.push(refreshBoards({
      id
    }))
  }

  batchedActions.push(setBoardsLoadStatus({
    id,
    loading: true,
    loaded: false
  }))

  yield put(batchedActions)

  try {
    const { BoardPermissions } = yield call(apiGetData, 'BoardsForGroup', {
      groupId: id
    })

    const batchedActions = [
      setBoardsLoadStatus({
        id,
        loading: false,
        loaded: true
      })
    ]

    if (BoardPermissions.length) {
      batchedActions.push(addBoardsToUserGroup({
        id,
        boards: BoardPermissions.map(BoardPermission => ({
          id: BoardPermission.Id,
          name: BoardPermission.Name,
          permissionLevel: BoardPermission.PermissionLevel
        }))
      }))
    }

    yield put(batchedActions)
  } catch (error) {
    yield put(setBoardsLoadStatus({
      id,
      loading: false,
      loaded: false
    }))

    throw error
  }
}
